var videoDataNormalizer=function(componentData,normalizerConfig){return void 0===componentData.disableDownload&&normalizerConfig.disableDownload&&(componentData.disableDownload=!0),componentData};export{videoDataNormalizer as default};
//# sourceMappingURL=videoDataNormalizer.js.map
